module.exports = __webpack_public_path__ + "static/media/Delivery.2b308c78.png";